import { render, staticRenderFns } from "./IconSectionSearch.vue?vue&type=template&id=05c15517&"
import script from "./IconSectionSearch.vue?vue&type=script&lang=js&"
export * from "./IconSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c15517')) {
      api.createRecord('05c15517', component.options)
    } else {
      api.reload('05c15517', component.options)
    }
    module.hot.accept("./IconSectionSearch.vue?vue&type=template&id=05c15517&", function () {
      api.rerender('05c15517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionSearch.vue"
export default component.exports